﻿$.fn.dxCtrlSondageQuestionTextBoxConsolide = function custom_dxCtrlSondageQuestionTextBoxConsolide(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlsondagequestiontextboxconsolide dx-ctrl");
        this.createInstance(new cdxCtrlSondageQuestionTextBoxConsolide(this, option));
    }
    return this;
}

window.cdxCtrlSondageQuestionTextBoxConsolide = function (container, option) {
    var Me = this;

    var BADGE = { txt: "Texte libre", bg: "#f2f1ee", color: "#52514e" };
    var BLEU = "#2a78d6";

    // état transitoire d'affichage (pas persisté dans option)
    var panneauOuvert = false;
    var resumeEnCours = false;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
            mConstruit();
        }
    }

    function mFormateNombre(n) {
        return n.toLocaleString("fr-FR");
    }
    function mFormateReponses(n) {
        return mFormateNombre(n) + (n > 1 ? " réponses" : " réponse");
    }

    var jauge = null
    function mConstruit() {
        container.empty();
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({height:60,width:60}).dxCtrlJauge("instance")

        var question = option.question || {};
        var nbReponses = option.nb_repondant || 0;

        // ---- En-tête : titre de la question, sous-titre, badge ----
        var titre = $("<div>").html(option.question.text_intro || "").text();
        var $titre = $("<h3>").text(titre).css({
            fontSize: "14px",
            fontWeight: "600",
            margin: "0 0 5px",
            color: "#0b0b0b"
        });

        var $sousTitre = $("<div>").text(mFormateReponses(nbReponses)).css({
            fontSize: "12.5px",
            color: "#898781"
        });

        var $titres = $("<div>").css({
            display: "flex",
            flexDirection: "column",
            gap: "5px",
            minWidth: "0"
        }).append($titre, $sousTitre);

        var $badge = $("<span>").text(BADGE.txt).css({
            flex: "none",
            fontSize: "11px",
            fontWeight: "700",
            padding: "4px 10px",
            borderRadius: "999px",
            whiteSpace: "nowrap",
            background: BADGE.bg,
            color: BADGE.color
        });

        var $entete = $("<div>").css({
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: "12px",
            //marginBottom: "14px"
        }).append($titres, $badge);

        container.append($entete);

        // ---- Aucune réponse reçue ----
        if (!option.resume || option.resume.length == 0) {
            return;
        }

        $("<div style='height:10px;'/>").appendTo(container)

        if (option.sondageConsolide.isUnitaire) {
            //on est unitaire, on affiche la réponse
            $("<div style='font-style:italic;font-size:90%;opacity:0.7;'/>").appendTo(container).html(option.resume)
        } else {
            //on a plusieurs réponse

            var $DivResume = $("<div style='font-style:italic;font-size:90%;height:80px;overflow:hidden;opacity:0.7;'/>").appendTo(container).html(option.resume)

            var $Table = $("<table style='width:100%;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='width:50%;white-space:nowrap;'/>").appendTo($Tr)
            var $lienFaire = $("<a href='javascript:void(0)'>✦ Faire un résumé</a>").appendTo($Td)
            $lienFaire.on("click", function () {
                jauge.mShow()
                $lienFaire.hide()
                $DivResume.animate({
                    height: "0px"
                }, 300, function () { });
                var intro = $("<div>").html(option.question.text_intro || "").text()
                option.bddCtrl.mAjaxCall({
                    command: "resumeiasondage",
                    question: "Voici une liste d'avis de plusieurs personnes qui répondent à un sondage.\n" +
                        "La question est: '" + intro + "'\n" +
                        "Fais un résumé **intelligent et structuré** de ces réponses, en HTML, **dans une seule div**. \n" +
                        "Tu es libre de choisir la structure (titres, listes, paragraphes, etc.) en fonction du contenu.\n" +
                        "**IMPORTANT :** \n" +
                        "- Ne renvoie **QUE le HTML de la div** (sans texte supplémentaire, sans balises ```, sans explications).\n" +
                        "- Ne rappelle **pas la question** dans le HTML.\n" +
                        "- n'utilise que des balises 'div' (pas de h1,h2,p...) avec du gras et italique si tu veux.\n" +
                        "- Limite-toi aux **10 points maximum les plus importants** ou aux **thèmes récurrents**. \n" +
                        "- Le résumé doit tenir en **moins de 1000 mots** (ou 50 lignes de HTML).\n" +
                        "- n'invente pas de réponse et limite toi au texte des réponse.\n" +
                        "- Le HTML doit être valide et prêt à être inséré dans une 'div'.\n\n" +
                        "Voici la liste des réponses:\n" + option.resume
                }, function (data) {
                    $lienHide.show()
                    $DivResumeIa.empty()
                    $("<div>").appendTo($DivResumeIa).html("<div style='font-size:130%;font-weight:bold;font-style:normal;'>Résumé " + (nbReponses > 1 ? "des " + nbReponses + " réponses" : "de la réponse") + "</div>" + data.reponse)
                    $DivResumeIa.slideDown(500)
                    jauge.mHide()
                })
            })
            var $lienHide = $("<a href='javascript:void(0)' style='display:none;'>✦ Cacher le résumé</a>").appendTo($Td)
            $lienHide.on("click", function () {
                $AMoins.trigger("click")
                $DivResumeIa.slideUp(500, function () { $DivResumeIa.empty() })
                $lienHide.hide()
                $lienFaire.show()
            })


            var $Td = $("<td style='width:50%;white-space:nowrap;text-align:right;'/>").appendTo($Tr)
            var $APlus = $("<a href='javascript:void(0)'>+ Voir plus</a>").appendTo($Td)
            $APlus.on("click", function (e) {
                $DivResume.animate({
                    height: $DivResume[0].scrollHeight
                }, 300, function () { $DivResume.css("height", "") });

                $APlus.hide();
                $AMoins.show()
            })
            var $AMoins = $("<a href='javascript:void(0)' style='display:none'>- Voir moins</a>").appendTo($Td)
            $AMoins.on("click", function (e) {
                $DivResume.animate({
                    height: "80px"
                }, 300, function () { $DivResume.css("height", "80px") });

                $APlus.show();
                $AMoins.hide()
            })

            var $DivResumeIa = $("<div style='display:none;padding-top:10px;font-style:italic;font-size:90%;opacity:0.7;padding-left:30px;'/>").appendTo(container)
        }

    }

    this.element = function () { return container; }
    this.component = function () { return Me; }

    mConstruit();
}